import React from 'react'
import SearchPicker from '../common/SearchPicker'

const OutsourcerPicker = (props) => {

    const { state } = props

    const option = (o) => <span>{`${o.code}, ${o.name}, ${o.currency}`}</span>

    return (
        <SearchPicker
            {...props}
            value={state ? `${state?.code}, ${state?.name}, ${state.currency}` : ""}
            option={(o) => option(o)}
        />
    )
}

export default OutsourcerPicker